// extracted by mini-css-extract-plugin
module.exports = {"logo":"layout_logo__22emA","bg":"layout_bg__qXLLF"};